import gql from 'graphql-tag'

export const authUserQuery = gql`
  query {
    authUser {
      id
      name
      email
      isAdmin
    }
  }
`

export const authTrainerQuery = gql`
  query {
    authTrainer {
      id
      name
      stripeConnectCode
    }
  }
`
